/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Link from '../Link';

class Navigation extends React.Component {

  componentDidMount() {
    // window.componentHandler.upgradeElement(this.refs.root);
  }

  componentWillUnmount() {
    // window.componentHandler.downgradeElements(this.refs.root);
  }

  render() {
    return (
      <nav ref="root">
        <Link to="/">Home</Link>
        <Link to="/catalog">Catalog</Link>
        <Link to="/catalog/latest/men">MEN</Link>
        <Link to="/catalog/WW1617/?gender=W">WOMEN</Link>
        <Link to="/catalog/product/GJF6001">TEST</Link>
        <Link to="/about">About</Link>
        <Link to="/not-found">Test</Link>
      </nav>
    );
  }

}

export default Navigation;



/** WEBPACK FOOTER **
 ** ./components/Layout/Navigation.js
 **/